import { OfferFilter } from "components/other/OfferFilter/OfferFilter.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getOfferEditHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/"
)({
    component: OfferFilterEditPage,
    staticData: {
        permissions: [PermissionEnum.OfferEditFilters],
        showInSideMenu: false,
        label: "pages.offer.edit.filter.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.edit.filter.title"),
    }),
});

function OfferFilterEditPage() {
    const { offerId } = Route.useParams();
    const offerFilterFormId = FormId.OfferFilterEditForm;
    const userUtils = useUser();
    const { t } = usePaldockTranslation("pages.offer.edit");

    return (
        <TenantPage
            headerNavigationItems={getOfferEditHeaderItems}
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? offerFilterFormId
                    : null
            }
            isEdit={true}
            detailLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/detail/$offerId/link",
                          params: { offerId: offerId },
                          label: t("offer_preview"),
                      }
                    : null
            }
        >
            <OfferFilter key={offerId} offerId={offerId} />
        </TenantPage>
    );
}
